<template>
  <div>
    <slot name="top" />

    <div class="sidebar-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.sidebar-content {
  padding: 30px;
}
</style>
